<div class="pc-contact">

    <app-profile-section-header title="Mi perfil"
                                subtitle="Consulta tu información personal y datos de contacto">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
            <circle cx="12" cy="8" r="4"/>
            <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <button headerActions class="edit-card__edit-btn" (click)="onEditClick()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="18" height="18">
                        <path d="M4 20h4l10-10-4-4L4 16v4z" stroke-linejoin="round"/>
                        <path d="M14 6l4 4" stroke-linecap="round"/>
            </svg>
            <span>Editar perfil</span>
        </button>
    </app-profile-section-header>

    <div class="pc-banner" *ngIf="show">
        <span class="pc-banner-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M8 12l3 3 5-6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
        <div class="pc-banner-text">
            <strong>¡Perfil completo al 100%!</strong>
            <span>Toda tu información está actualizada</span>
        </div>
    </div>

    <div class="pc-card">
        <h3 class="pc-card-title"><span class="pc-card-bar"></span>Datos personales</h3>
        <div class="pc-grid">
            <div class="pc-field full">
                <label>Nombre completo</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <circle cx="12" cy="8" r="4"/>
                                    <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                            <span>{{profileData?.name}} {{profileData?.surname}} {{profileData?.lastName}}</span>
                </div>
            </div>
            <div class="pc-field">
                <label>Documento de identidad</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <rect x="3" y="5" width="18" height="14" rx="2"/>
                                    <circle cx="9" cy="11" r="2"/>
                                    <path d="M5 17c1-2 3-3 4-3s3 1 4 3M14 9h5M14 13h5" stroke-linecap="round"/>
                        </svg>
                    </span>
                            <span>{{profileData?.documentNumber}}</span>
                </div>
            </div>
                    <div class="pc-field" *ngIf="!isCompany">
                <label>Fecha de nacimiento</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <rect x="3" y="5" width="18" height="16" rx="2"/>
                                    <line x1="3" y1="10" x2="21" y2="10"/>
                                    <line x1="8" y1="3" x2="8" y2="7"/>
                                    <line x1="16" y1="3" x2="16" y2="7"/>
                        </svg>
                    </span>
                            <span>{{ birthDateFormatted }}</span>
                </div>
            </div>
            <div class="pc-field">
                <label>Correo electrónico</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <rect x="3" y="5" width="18" height="14" rx="2"/>
                                    <path d="M3 7l9 6 9-6" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                            <span>{{profileData?.email}}</span>
                </div>
            </div>
            <div class="pc-field">
                <label>Teléfono móvil</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <rect x="6" y="3" width="12" height="18" rx="2"/>
                                    <line x1="11" y1="18" x2="13" y2="18" stroke-linecap="round"/>
                        </svg>
                    </span>
                            <!-- El campo es el movil: ha de pintar el getter mobilePhone, no el del fijo. -->
                            <span>{{mobilePhone}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="pc-card">
        <h3 class="pc-card-title"><span class="pc-card-bar"></span>Domicilio</h3>
        <div class="pc-field full">
            <label>Dirección</label>
            <div class="pc-field-value">
                <span class="pc-field-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                <path d="M3 11l9-7 9 7v9a2 2 0 0 1-2 2h-3v-6h-8v6H5a2 2 0 0 1-2-2v-9z" stroke-linejoin="round"/>
                    </svg>
                </span>
                <div class="pc-field-multiline">
                            <span>{{profileData?.address}} {{profileData?.number}} {{profileData?.portal}} {{profileData?.stair}} {{profileData?.floor}} {{profileData?.door}}</span>
                            <span class="pc-field-sub">{{poblacion}},</span>
                </div>
            </div>
        </div>
    </div>

</div>